import { render } from "./ImovelDetailsPage.vue?vue&type=template&id=77648fc8&scoped=true"
import script from "./ImovelDetailsPage.vue?vue&type=script&lang=js"
export * from "./ImovelDetailsPage.vue?vue&type=script&lang=js"

import "./ImovelDetailsPage.vue?vue&type=style&index=0&id=77648fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77648fc8"]])

export default __exports__